import React from 'react';
import { useInView } from '../hooks/useInView';

const animationClasses = {
  'fade-up': 'animate-on-scroll',
  'fade-down': 'animate-on-scroll-down',
  'fade-left': 'animate-on-scroll-left',
  'fade-right': 'animate-on-scroll-right',
  'scale-up': 'animate-on-scroll-scale',
  'fade': 'animate-on-scroll-fade',
};

const AnimateOnScroll = ({
  children,
  animation = 'fade-up',
  delay = 0,
  className = '',
  as: Tag = 'div',
}) => {
  const [ref, isInView] = useInView({ threshold: 0.12 });
  const animClass = animationClasses[animation] || animationClasses['fade-up'];

  return (
    <Tag
      ref={ref}
      className={`${animClass} ${isInView ? 'in-view' : ''} ${className}`}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </Tag>
  );
};

export default AnimateOnScroll;
